import AndorrA from "./flags/ad.png";
import UnitedArabEmirates from "./flags/ae.png";
import Afghanistan from "./flags/af.png";
import AntiguaandBarbuda from "./flags/ag.png";
import Anguilla from "./flags/ai.png";
import Albania from "./flags/al.png";
import Armenia from "./flags/am.png";
import Angola from "./flags/ao.png";
import Antarctica from "./flags/aq.png";
import Argentina from "./flags/ar.png";
import AmericanSamoa from "./flags/as.png";
import Austria from "./flags/at.png";
import Australia from "./flags/au.png";
import Aruba from "./flags/aw.png";
import landIslands from "./flags/ax.png";
import Azerbaijan from "./flags/az.png";
import BosniaandHerzegovina from "./flags/ba.png";
import Barbados from "./flags/bb.png";
import Bangladesh from "./flags/bd.png";
import Belgium from "./flags/be.png";
import BurkinaFaso from "./flags/bf.png";
import Bulgaria from "./flags/bg.png";
import Bahrain from "./flags/bh.png";
import Burundi from "./flags/bi.png";
import Benin from "./flags/bj.png";
import Bermuda from "./flags/bm.png";
import BruneiDarussalam from "./flags/bn.png";
import Bolivia from "./flags/bo.png";
import Brazil from "./flags/br.png";
import Bahamas from "./flags/bs.png";
import Bhutan from "./flags/bt.png";
import BouvetIsland from "./flags/bv.png";
import Botswana from "./flags/bw.png";
import Belarus from "./flags/by.png";
import Belize from "./flags/bz.png";
import Canada from "./flags/ca.png";
import CocosKeelingIslands from "./flags/cc.png";
import CongoTheDemocraticRepublicofthe from "./flags/cd.png";
import CentralAfricanRepublic from "./flags/cf.png";
import Congo from "./flags/cg.png";
import Switzerland from "./flags/ch.png";
import CoteDIvoire from "./flags/ci.png";
import CookIslands from "./flags/ck.png";
import Chile from "./flags/cl.png";
import Cameroon from "./flags/cm.png";
import China from "./flags/cn.png";
import Colombia from "./flags/co.png";
import CostaRica from "./flags/cr.png";
import Cuba from "./flags/cu.png";
import CapeVerde from "./flags/cv.png";
import ChristmasIsland from "./flags/cx.png";
import Cyprus from "./flags/cy.png";
import CzechRepublic from "./flags/cz.png";
import Germany from "./flags/de.png";
import Djibouti from "./flags/dj.png";
import Denmark from "./flags/dk.png";
import Dominica from "./flags/dm.png";
import DominicanRepublic from "./flags/do.png";
import Algeria from "./flags/dz.png";
import Ecuador from "./flags/ec.png";
import Estonia from "./flags/ee.png";
import Egypt from "./flags/eg.png";
import WesternSahara from "./flags/eh.png";
import Eritrea from "./flags/er.png";
import Spain from "./flags/es.png";
import Ethiopia from "./flags/et.png";
import Finland from "./flags/fi.png";
import Fiji from "./flags/fj.png";
import FalklandIslandsMalvinas from "./flags/fk.png";
import MicronesiaFederatedStatesof from "./flags/fm.png";
import FaroeIslands from "./flags/fo.png";
import France from "./flags/fr.png";
import Gabon from "./flags/ga.png";
import UnitedKingdom from "./flags/gb.png";
import Grenada from "./flags/gd.png";
import Georgia from "./flags/ge.png";
import FrenchGuiana from "./flags/gf.png";
import Guernsey from "./flags/gg.png";
import Ghana from "./flags/gh.png";
import Gibraltar from "./flags/gi.png";
import Greenland from "./flags/gl.png";
import Gambia from "./flags/gm.png";
import Guinea from "./flags/gn.png";
import Guadeloupe from "./flags/gp.png";
import EquatorialGuinea from "./flags/gq.png";
import Greece from "./flags/gr.png";
import SouthGeorgiaandtheSouthSandwichIslands from "./flags/gs.png";
import Guatemala from "./flags/gt.png";
import Guam from "./flags/gu.png";
import GuineaBissau from "./flags/gw.png";
import Guyana from "./flags/gy.png";
import HongKong from "./flags/hk.png";
import HeardIslandandMcdonaldIslands from "./flags/hm.png";
import Honduras from "./flags/hn.png";
import Croatia from "./flags/hr.png";
import Haiti from "./flags/ht.png";
import Hungary from "./flags/hu.png";
import Indonesia from "./flags/id.png";
import Ireland from "./flags/ie.png";
import Israel from "./flags/il.png";
import IsleofMan from "./flags/im.png";
import India from "./flags/in.png";
import BritishIndianOceanTerritory from "./flags/io.png";
import Iraq from "./flags/iq.png";
import IranIslamicRepublicOf from "./flags/ir.png";
import Iceland from "./flags/is.png";
import Italy from "./flags/it.png";
import Jersey from "./flags/je.png";
import Jamaica from "./flags/jm.png";
import Jordan from "./flags/jo.png";
import Japan from "./flags/jp.png";
import Kenya from "./flags/ke.png";
import Kyrgyzstan from "./flags/kg.png";
import Cambodia from "./flags/kh.png";
import Kiribati from "./flags/ki.png";
import Comoros from "./flags/km.png";
import SaintKittsandNevis from "./flags/kn.png";
import KoreaDemocraticPeopleSRepublicof from "./flags/kp.png";
import KoreaRepublicof from "./flags/kr.png";
import Kuwait from "./flags/kw.png";
import CaymanIslands from "./flags/ky.png";
import Kazakhstan from "./flags/kz.png";
import LaoPeopleSDemocraticRepublic from "./flags/la.png";
import Lebanon from "./flags/lb.png";
import SaintLucia from "./flags/lc.png";
import Liechtenstein from "./flags/li.png";
import SriLanka from "./flags/lk.png";
import Liberia from "./flags/lr.png";
import Lesotho from "./flags/ls.png";
import Lithuania from "./flags/lt.png";
import Luxembourg from "./flags/lu.png";
import Latvia from "./flags/lv.png";
import LibyanArabJamahiriya from "./flags/ly.png";
import Morocco from "./flags/ma.png";
import Monaco from "./flags/mc.png";
import MoldovaRepublicof from "./flags/md.png";
import Madagascar from "./flags/mg.png";
import MarshallIslands from "./flags/mh.png";
import MacedoniaTheFormerYugoslavRepublicof from "./flags/mk.png";
import Mali from "./flags/ml.png";
import Myanmar from "./flags/mm.png";
import Mongolia from "./flags/mn.png";
import Macao from "./flags/mo.png";
import NorthernMarianaIslands from "./flags/mp.png";
import Martinique from "./flags/mq.png";
import Mauritania from "./flags/mr.png";
import Montserrat from "./flags/ms.png";
import Malta from "./flags/mt.png";
import Mauritius from "./flags/mu.png";
import Maldives from "./flags/mv.png";
import Malawi from "./flags/mw.png";
import Mexico from "./flags/mx.png";
import Malaysia from "./flags/my.png";
import Mozambique from "./flags/mz.png";
import Namibia from "./flags/na.png";
import NewCaledonia from "./flags/nc.png";
import Niger from "./flags/ne.png";
import NorfolkIsland from "./flags/nf.png";
import Nigeria from "./flags/ng.png";
import Nicaragua from "./flags/ni.png";
import Netherlands from "./flags/nl.png";
import Norway from "./flags/no.png";
import Nepal from "./flags/np.png";
import Nauru from "./flags/nr.png";
import Niue from "./flags/nu.png";
import NewZealand from "./flags/nz.png";
import Oman from "./flags/om.png";
import Panama from "./flags/pa.png";
import Peru from "./flags/pe.png";
import FrenchPolynesia from "./flags/pf.png";
import PapuaNewGuinea from "./flags/pg.png";
import Philippines from "./flags/ph.png";
import Pakistan from "./flags/pk.png";
import Poland from "./flags/pl.png";
import SaintPierreandMiquelon from "./flags/pm.png";
import Pitcairn from "./flags/pn.png";
import PuertoRico from "./flags/pr.png";
import PalestinianTerritoryOccupied from "./flags/ps.png";
import Portugal from "./flags/pt.png";
import Palau from "./flags/pw.png";
import Paraguay from "./flags/py.png";
import Qatar from "./flags/qa.png";
import Reunion from "./flags/re.png";
import Romania from "./flags/ro.png";
import RussianFederation from "./flags/ru.png";
import RWANDA from "./flags/rw.png";
import SaudiArabia from "./flags/sa.png";
import SolomonIslands from "./flags/sb.png";
import Seychelles from "./flags/sc.png";
import Sudan from "./flags/sd.png";
import Sweden from "./flags/se.png";
import Singapore from "./flags/sg.png";
import SaintHelena from "./flags/sh.png";
import Slovenia from "./flags/si.png";
import SvalbardandJanMayen from "./flags/sj.png";
import Slovakia from "./flags/sk.png";
import SierraLeone from "./flags/sl.png";
import SanMarino from "./flags/sm.png";
import Senegal from "./flags/sn.png";
import Somalia from "./flags/so.png";
import Suriname from "./flags/sr.png";
import SaoTomeandPrincipe from "./flags/st.png";
import ElSalvador from "./flags/sv.png";
import SyrianArabRepublic from "./flags/sy.png";
import Swaziland from "./flags/sz.png";
import TurksandCaicosIslands from "./flags/tc.png";
import Chad from "./flags/td.png";
import FrenchSouthernTerritories from "./flags/tf.png";
import Togo from "./flags/tg.png";
import Thailand from "./flags/th.png";
import Tajikistan from "./flags/tj.png";
import Tokelau from "./flags/tk.png";
import TimorLeste from "./flags/tl.png";
import Turkmenistan from "./flags/tm.png";
import Tunisia from "./flags/tn.png";
import Tonga from "./flags/to.png";
import Turkey from "./flags/tr.png";
import TrinidadandTobago from "./flags/tt.png";
import Tuvalu from "./flags/tv.png";
import TaiwanProvinceofChina from "./flags/tw.png";
import TanzaniaUnitedRepublicof from "./flags/tz.png";
import Ukraine from "./flags/ua.png";
import Uganda from "./flags/ug.png";
import UnitedStatesMinorOutlyingIslands from "./flags/um.png";
import UnitedStates from "./flags/us.png";
import Uruguay from "./flags/uy.png";
import Uzbekistan from "./flags/uz.png";
import HolySeeVaticanCityState from "./flags/va.png";
import SaintVincentandtheGrenadines from "./flags/vc.png";
import Venezuela from "./flags/ve.png";
import VirginIslandsBritish from "./flags/vg.png";
import VirginIslandsUS from "./flags/vi.png";
import VietNam from "./flags/vn.png";
import Vanuatu from "./flags/vu.png";
import WallisandFutuna from "./flags/wf.png";
import Samoa from "./flags/ws.png";
import Yemen from "./flags/ye.png";
import Mayotte from "./flags/yt.png";
import SouthAfrica from "./flags/za.png";
import Zambia from "./flags/zm.png";
import Zimbabwe from "./flags/zw.png";
import Zaire from "./flags/zr.png";
import All from "./flags/all.png";
import Any from "./flags/all.png";
interface Flags {
  [key: string]: string;
}

const flags: Flags = {
  OO:All,
  All: All,
  ANY: Any,
  AD: AndorrA,
  AE: UnitedArabEmirates,
  AF: Afghanistan,
  AG: AntiguaandBarbuda,
  AI: Anguilla,
  AL: Albania,
  AM: Armenia,
  AO: Angola,
  AQ: Antarctica,
  AR: Argentina,
  AS: AmericanSamoa,
  DS: AmericanSamoa,
  AT: Austria,
  AU: Australia,
  AW: Aruba,
  AX: landIslands,
  AZ: Azerbaijan,
  BA: BosniaandHerzegovina,
  BB: Barbados,
  BD: Bangladesh,
  BE: Belgium,
  BF: BurkinaFaso,
  BG: Bulgaria,
  BH: Bahrain,
  BI: Burundi,
  BJ: Benin,
  BM: Bermuda,
  BN: BruneiDarussalam,
  BO: Bolivia,
  BR: Brazil,
  BS: Bahamas,
  BT: Bhutan,
  BV: BouvetIsland,
  BW: Botswana,
  BY: Belarus,
  BZ: Belize,
  CA: Canada,
  CC: CocosKeelingIslands,
  CD: CongoTheDemocraticRepublicofthe,
  CF: CentralAfricanRepublic,
  CG: Congo,
  CH: Switzerland,
  CI: CoteDIvoire,
  CK: CookIslands,
  CL: Chile,
  CM: Cameroon,
  CN: China,
  CO: Colombia,
  CR: CostaRica,
  CU: Cuba,
  CV: CapeVerde,
  CX: ChristmasIsland,
  CY: Cyprus,
  CZ: CzechRepublic,
  DE: Germany,
  DJ: Djibouti,
  DK: Denmark,
  DM: Dominica,
  DO: DominicanRepublic,
  DZ: Algeria,
  EC: Ecuador,
  EE: Estonia,
  EG: Egypt,
  EH: WesternSahara,
  ER: Eritrea,
  ES: Spain,
  ET: Ethiopia,
  FI: Finland,
  FJ: Fiji,
  FK: FalklandIslandsMalvinas,
  FM: MicronesiaFederatedStatesof,
  FO: FaroeIslands,
  FR: France,
  GA: Gabon,
  GB: UnitedKingdom,
  GD: Grenada,
  GE: Georgia,
  GF: FrenchGuiana,
  GG: Guernsey,
  GH: Ghana,
  GI: Gibraltar,
  GL: Greenland,
  GM: Gambia,
  GN: Guinea,
  GP: Guadeloupe,
  GQ: EquatorialGuinea,
  GR: Greece,
  GS: SouthGeorgiaandtheSouthSandwichIslands,
  GT: Guatemala,
  GU: Guam,
  GW: GuineaBissau,
  GY: Guyana,
  HK: HongKong,
  HM: HeardIslandandMcdonaldIslands,
  HN: Honduras,
  HR: Croatia,
  HT: Haiti,
  HU: Hungary,
  ID: Indonesia,
  IE: Ireland,
  IL: Israel,
  IM: IsleofMan,
  IN: India,
  IO: BritishIndianOceanTerritory,
  IQ: Iraq,
  IR: IranIslamicRepublicOf,
  IS: Iceland,
  IT: Italy,
  JE: Jersey,
  JM: Jamaica,
  JO: Jordan,
  JP: Japan,
  KE: Kenya,
  KG: Kyrgyzstan,
  KH: Cambodia,
  KI: Kiribati,
  KM: Comoros,
  KN: SaintKittsandNevis,
  KP: KoreaDemocraticPeopleSRepublicof,
  KR: KoreaRepublicof,
  KW: Kuwait,
  KY: CaymanIslands,
  KZ: Kazakhstan,
  LA: LaoPeopleSDemocraticRepublic,
  LB: Lebanon,
  LC: SaintLucia,
  LI: Liechtenstein,
  LK: SriLanka,
  LR: Liberia,
  LS: Lesotho,
  LT: Lithuania,
  LU: Luxembourg,
  LV: Latvia,
  LY: LibyanArabJamahiriya,
  MA: Morocco,
  MC: Monaco,
  MD: MoldovaRepublicof,
  MG: Madagascar,
  MH: MarshallIslands,
  MK: MacedoniaTheFormerYugoslavRepublicof,
  ML: Mali,
  MM: Myanmar,
  MN: Mongolia,
  MO: Macao,
  MP: NorthernMarianaIslands,
  MQ: Martinique,
  MR: Mauritania,
  MS: Montserrat,
  MT: Malta,
  MU: Mauritius,
  MV: Maldives,
  MW: Malawi,
  MX: Mexico,
  MY: Malaysia,
  MZ: Mozambique,
  NA: Namibia,
  NC: NewCaledonia,
  NE: Niger,
  NF: NorfolkIsland,
  NG: Nigeria,
  NI: Nicaragua,
  NL: Netherlands,
  NO: Norway,
  NP: Nepal,
  NR: Nauru,
  NU: Niue,
  NZ: NewZealand,
  OM: Oman,
  PA: Panama,
  PE: Peru,
  PF: FrenchPolynesia,
  PG: PapuaNewGuinea,
  PH: Philippines,
  PK: Pakistan,
  PL: Poland,
  PM: SaintPierreandMiquelon,
  PN: Pitcairn,
  PR: PuertoRico,
  PS: PalestinianTerritoryOccupied,
  PT: Portugal,
  PW: Palau,
  PY: Paraguay,
  QA: Qatar,
  RE: Reunion,
  RO: Romania,
  RU: RussianFederation,
  RW: RWANDA,
  SA: SaudiArabia,
  SB: SolomonIslands,
  SC: Seychelles,
  SD: Sudan,
  SE: Sweden,
  SG: Singapore,
  SH: SaintHelena,
  SI: Slovenia,
  SJ: SvalbardandJanMayen,
  SK: Slovakia,
  SL: SierraLeone,
  SM: SanMarino,
  SN: Senegal,
  SO: Somalia,
  SR: Suriname,
  ST: SaoTomeandPrincipe,
  SV: ElSalvador,
  SY: SyrianArabRepublic,
  SZ: Swaziland,
  TC: TurksandCaicosIslands,
  TD: Chad,
  TF: FrenchSouthernTerritories,
  TG: Togo,
  TH: Thailand,
  TJ: Tajikistan,
  TK: Tokelau,
  TL: TimorLeste,
  TM: Turkmenistan,
  TN: Tunisia,
  TO: Tonga,
  TR: Turkey,
  TT: TrinidadandTobago,
  TV: Tuvalu,
  TW: TaiwanProvinceofChina,
  TZ: TanzaniaUnitedRepublicof,
  UA: Ukraine,
  UG: Uganda,
  UM: UnitedStatesMinorOutlyingIslands,
  US: UnitedStates,
  UY: Uruguay,
  UZ: Uzbekistan,
  UK: UnitedKingdom,
  VA: HolySeeVaticanCityState,
  VC: SaintVincentandtheGrenadines,
  VE: Venezuela,
  VG: VirginIslandsBritish,
  VI: VirginIslandsUS,
  VN: VietNam,
  VU: Vanuatu,
  WF: WallisandFutuna,
  WS: Samoa,
  YE: Yemen,
  YT: Mayotte,
  ZA: SouthAfrica,
  ZM: Zambia,
  ZW: Zimbabwe,
  ZR: Zaire,
};

type Props = {
  code: string;
  w?: string;
  h?: string;
};

const FlagIcon: React.FC<Props> = ({ code, w = "26px", h = "23px" }: Props) => {
  return (
    <img
      loading="lazy"
      style={{
        marginRight: "10px",
        borderRadius: "50%",
        width: w,
        height: h,
      }}
      src={flags[code?.toLocaleUpperCase() || "OO"]}
      alt={code}
    />
  );
};

export default FlagIcon;
